import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
  tableCellClasses,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ITechnicalSubmissionItem } from 'types/submissions'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}))

const StyledTypography = styled(Typography)({
  fontWeight: '600',
  lineHeight: '20px',
  marginBottom: '15px',
})

type Props = {
  technicalSubmissionItems: ITechnicalSubmissionItem[]
}

export const TechnicalResultSubmission = ({ technicalSubmissionItems }: Props) => {
  const { t } = useTranslation()
  return (
    <TableContainer>
      <Table
        sx={{
          tableLayout: 'fixed',
          '& td, th': {
            border: '1px solid #ccc',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <StyledTableCell>{t('evaluationOfDocuments')}</StyledTableCell>
            <StyledTableCell>{t('contractorOfferAndNotes')}</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {technicalSubmissionItems?.map((sub) => {
            return (
              <TableRow key={sub.id}>
                <TableCell>
                  <StyledTypography>
                    {t('tender-proposal-price-description')}
                  </StyledTypography>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          <Stack spacing={3}>
                            <TextField
                              disabled
                              label={t('criteria-name')}
                              fullWidth
                              defaultValue={sub.technicalRequirementItem?.criteria}
                              InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                              disabled
                              label={t('criteria-point')}
                              fullWidth
                              defaultValue={sub.technicalRequirementItem?.point}
                              InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                              defaultValue={
                                sub.technicalRequirementItem?.eligibility
                              }
                              disabled
                              fullWidth
                              label={t('evaluationMethod')}
                              InputProps={{
                                rows: 2,
                                multiline: true,
                                inputComponent: 'textarea',
                              }}
                              InputLabelProps={{ shrink: true }}
                            />
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableCell>
                <TableCell sx={{ verticalAlign: 'top' }}>
                  <StyledTypography>
                    {t('tender-proposal-final-price')}
                  </StyledTypography>
                  <Stack spacing={3}>
                    <TextField
                      defaultValue={sub.reply}
                      disabled
                      fullWidth
                      label={t('answer')}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      defaultValue={sub.note}
                      disabled
                      fullWidth
                      label={t('contractor-notes')}
                      InputProps={{
                        rows: 2,
                        multiline: true,
                        inputComponent: 'textarea',
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Stack>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
